import { alpha } from '@mui/material';

// driver.js popover styles from the MUI theme, so the tour follows dark mode and broker colours.
// Everything is !important: driver.css uses the same selectors and its load order isn't guaranteed.
export const getTourGlobalStyles = (theme) => {
  const { palette } = theme;
  const important = (value) => `${value} !important`;

  const buttonBase = {
    borderRadius: important('8px'),
    fontSize: important('13px'),
    fontWeight: important(600),
    lineHeight: important(1.3),
    padding: important('6px 12px'),
    textShadow: important('none'),
    transition: important('background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease'),
    // driver.css removes the browser outline, so keyboard focus needs its own indicator
    '&:focus-visible': {
      outline: important(`2px solid ${palette.primary.main}`),
      outlineOffset: important('2px'),
    },
  };

  const outlinedButton = {
    ...buttonBase,
    color: important(palette.text.secondary),
    backgroundColor: important('transparent'),
    border: important(`1px solid ${palette.divider}`),
    '&:hover': {
      color: important(palette.text.primary),
      backgroundColor: important(palette.action.hover),
    },
  };

  const containedButton = {
    ...buttonBase,
    color: important(palette.primary.contrastText),
    backgroundColor: important(palette.primary.main),
    border: important(`1px solid ${palette.primary.main}`),
    '&:hover': {
      backgroundColor: important(palette.primary.dark),
      borderColor: important(palette.primary.dark),
    },
  };

  const arrowColor = important(palette.background.paper);

  return {
    '.driver-popover': {
      borderRadius: important('12px'),
      fontFamily: important(theme.typography.fontFamily),
      boxShadow: important(`0 10px 30px ${alpha(palette.common.black, 0.2)}`),
      maxWidth: important('320px'),
      backgroundColor: important(palette.background.paper),
      color: important(palette.text.primary),
    },
    '.driver-popover-title': {
      fontSize: important('1.1rem'),
      fontWeight: important(700),
      marginBottom: important('8px'),
      // Leave room for the Skip button in the top-right corner
      paddingRight: important('64px'),
    },
    '.driver-popover-description': {
      fontSize: important('0.9rem'),
      lineHeight: important(1.5),
      color: important(palette.text.secondary),
    },
    '.driver-popover-progress-text': {
      color: important(palette.text.secondary),
    },
    '.driver-popover-footer': {
      marginTop: important('16px'),
    },
    '.driver-popover-prev-btn': outlinedButton,
    // driver.js adds `done-btn` to the next button on the last step
    '.driver-popover-next-btn, .driver-popover-done-btn': containedButton,
    '.driver-popover-close-btn': {
      ...outlinedButton,
      top: important('12px'),
      right: important('16px'),
      width: important('auto'),
      height: important('auto'),
    },
    // The arrow is drawn with borders; colour only the side that points at the target
    '.driver-popover-arrow-side-left': { borderLeftColor: arrowColor },
    '.driver-popover-arrow-side-right': { borderRightColor: arrowColor },
    '.driver-popover-arrow-side-top': { borderTopColor: arrowColor },
    '.driver-popover-arrow-side-bottom': { borderBottomColor: arrowColor },
  };
};
